import type { SavedFile } from "./files.types";

export enum MaterialStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}

export type Material = {
	id?: number;
	createdAt?: Date;
	updatedAt?: Date;
	label: string;
	sageId: string;
	status: MaterialStatus;
	number: string;
	fileId: number | null;
	file: File | SavedFile | null;
};

export type MaterialLog = {
	id?: number;
	createdAt?: Date;
	updatedAt?: Date;
	materialId: number;
	number: string;
};
